// utils/agruparData.ts

export const agruparUsuariosPorMesAno = (usuarios: any[]) => {
  const agrupado: Record<string, number> = {}; // Define um objeto para armazenar o agrupamento

  usuarios.forEach((usuario) => {
    // Converte a data do formato "DD/MM/YYYY"
    const [dia, mes, ano] = usuario.created_at.split("/").map(Number); // Desestrutura e converte para número
    const data = new Date(ano, mes - 1, dia); // Cria um objeto Date (mes - 1 porque é zero-indexado)

    // Verifica se a data é válida
    if (isNaN(data.getTime())) {
      console.warn(`Data inválida para o usuário: ${usuario.created_at}`); // Log para depuração
      return; // Ignora este usuário se a data não for válida
    }

    const mesAno = `${data.getMonth() + 1}/${data.getFullYear()}`; // Formato MM/AAAA

    // Incrementa o contador para o mês/ano
    agrupado[mesAno] = (agrupado[mesAno] || 0) + 1;
  });

  return Object.entries(agrupado); // Retorna um array de [chave, valor]
};
